import { render, staticRenderFns } from "./locationAndCounts.vue?vue&type=template&id=14cbb06c&scoped=true&"
import script from "./locationAndCounts.vue?vue&type=script&lang=js&"
export * from "./locationAndCounts.vue?vue&type=script&lang=js&"
import style0 from "./locationAndCounts.vue?vue&type=style&index=0&id=14cbb06c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cbb06c",
  null
  
)

export default component.exports